import React from 'react';
import '../../Static/Master/SalepartyReg.css';

const SearchPagination = ({
    handleItemsPerPageChange,
    handleSearchChange,
    searchTerm,
    totalItems
}) => {

    // Default pagination steps
    const defaultOptions = [10, 25, 50, 100];

    let filteredOptions = [];

    if (totalItems <= 100) {
        filteredOptions = defaultOptions.filter(opt => opt < totalItems);

        // Add totalItems if it's not already included
        if (!filteredOptions.includes(totalItems)) {
            filteredOptions.push(totalItems);
        }

        filteredOptions.sort((a, b) => a - b);
    } else {
        filteredOptions = [...defaultOptions];

        // Add "All" option
        if (!filteredOptions.includes(totalItems)) {
            filteredOptions.push(totalItems);
        }

        filteredOptions.sort((a, b) => a - b);
    }

    return (
        <div className='div-select'>
            <span>Show</span>
            <select onChange={handleItemsPerPageChange} id='select'>
                {filteredOptions.map(option => (
                    <option key={option} value={option}>
                        {option === totalItems && totalItems > 100
                            ? `All (${totalItems})`
                            : option}
                    </option>
                ))}
            </select>
            <span>Entries</span>

            <label className="input-label1">
                Search:
                <input
                    id='inpt'
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
            </label>
        </div>
    );
};

export default React.memo(SearchPagination);
